import { Flex } from "@chakra-ui/react";

export default function HeaderTable({
  saldoParcial,
}: {
  saldoParcial?: boolean;
}) {
  return (
    <Flex bg="#EBEBEB" px={8} py={2} h="60px" align="center">
      <Flex w="100%" gap={6}>
        <Flex flex={1} fontWeight="medium">
          Débito
        </Flex>
        <Flex flex={1} fontWeight="medium">
          Crédito
        </Flex>
        <Flex flex={1.6} mr={10} fontWeight="medium">
          Histórico
        </Flex>
        <Flex ml={2} flex={0.4} fontWeight="medium" justifyContent="flex-end">
          Valor (R$)
        </Flex>
        {saldoParcial ? (
          <Flex ml={2} flex={0.4} fontWeight="medium" justifyContent="flex-end">
            Saldo parcial
          </Flex>
        ) : null}
      </Flex>
    </Flex>
  );
}
